import script from './alpha-slider.vue_vue&type=script&lang.mjs';
export { default } from './alpha-slider.vue_vue&type=script&lang.mjs';
import { render } from './alpha-slider.vue_vue&type=template&id=4fb2624c&lang.mjs';

script.render = render;
script.__file = "packages/components/color-picker/src/components/alpha-slider.vue";
//# sourceMappingURL=alpha-slider.mjs.map
